import $ from 'jquery';

jQuery(document).ready(function($) {
    // Set up scroll behavior for all internal links containing a #
    $('a[href*="#"]').on('click', function(e) {
        // Check if the link is internal (same domain) and not an external link
        if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
            e.preventDefault(); // Prevent the default jump to the anchor

            // Get the target element
            var target = $(this.hash);
            var headerHeight = $('#header').outerHeight(); // Get the height of the header

            // If the target element exists
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - headerHeight - 60 // Scroll to the element considering the header height
                }, 1000); // Animation duration (1000 ms = 1 second)
            }
        }
    });

    // Check if the URL contains a hash on page load
    if (window.location.hash) {
        var target = $(window.location.hash);
        var headerHeight = $('#header').outerHeight();

        // Smooth scroll to the element on page load if there is a hash
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - headerHeight - 60
            }, 1000);
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/partials/links.js